import React from "react";
import {HeroImageSection} from "../components/common/HeroImageSection";
import {TwoColumnSliderSection} from "../components/TwoColumnSlider";

const RestaurantPage: React.FC = () => {

    const restaurantSlides = [
        {
            image: '/images/restaurant_1.webp'
        },
        {
            image: '/images/restaurant_2.webp'
        },
        {
            image: '/images/restaurant_3.webp'
        },
    ]

    const barSlides = [
        {
            image: '/images/bar_1.webp'
        },
        {
            image: '/images/bar_2.webp'
        },
        {
            image: '/images/bar_3.webp'
        },
    ]

    const cafeSlides = [
        {
            image: '/images/cafe_1.webp'
        },
        {
            image: '/images/cafe_2.webp'
        },
        {
            image: '/images/cafe_3.webp'
        },
    ]

    return (
        <div className="bg-dark-mode text-ivory">
            <HeroImageSection
                image="/images/culinary_banner.webp"
                text="RESTAURANTS & BAR"
                nextSectionId="multicuisine-restaurant-section"/>
            <TwoColumnSliderSection
                id="multicuisine-restaurant-section"
                title="MULTICUISINE RESTAURANT"
                slides={restaurantSlides}/>
            <TwoColumnSliderSection
                id="bar-section"
                title="BAR"
                slides={barSlides}
                isDark={true}/>
            <TwoColumnSliderSection
                id="cafe-section"
                title="CAFE"
                slides={cafeSlides}/>
        </div>
    );
};

export default RestaurantPage;